module.exports = __webpack_public_path__ + "img/cartrackerLogo.0cfae8f1.png";